<div class="bg"></div>
<div class="app-header">
  <div class="app-header__top-container">
    <div class="app-header__top-logo">
      <div class="bosch-logo" [class.cursor-null]="isSalesPortal"
        (click)="!isSalesPortal ? goHome('home/index') : null">
      </div>
    </div>
    <!-- link container -->
    <div class="app-header__top-link">
      <!-- Not logged -->
      <span class="link-box sm:flex mx:flex" (click)="userLogin()" *ngIf="!isLogin">
        <!-- <span class="link-box sm:flex mx:flex" (click)="userLogin()" *ngIf="!isLogin"> -->
        <span class="pr-2">{{"HOME_SIGN_IN" | translate}}</span>
        <svg-icon class="header-content-right-icon" [size]="24" [iconName]="'login.svg'"></svg-icon>
      </span>
      <!-- Not logged & ??Login Status === 2?? -->
      <div *ngIf="isLogin" nz-popover [nzPopoverContent]="userTemplate">
        <span class="link-box flex">
          <span class="pr-2">{{ userData?.queryUserPageInfoResDTO?.name ?? "--" }}</span>
          <svg-icon class="header-content-right-icon" [size]="24" [iconName]="'login.svg'"></svg-icon>
        </span>
      </div>
      <!-- Login Status is Successed -->
      <!-- message tip -->
      <span class="link-box sm:hidden mx:flex" *ngIf="isLogin && userData?.queryUserPageInfoResDTO?.status==2">
        <svg-icon (click)="showMessage()" [iconName]="'msg.svg'"></svg-icon>
        <span class="font16-w500" *ngIf="notificationUnReadTotal> 0">{{notificationUnReadTotal}}</span>
      </span>
      <!-- shopping cart -->
      <div nz-popover class="sm:hidden" *ngIf="isLogin && userData?.queryUserPageInfoResDTO?.status==2"
        [nzPopoverPlacement]="'bottom'" [nzPopoverContent]="cartTemplate">

        <span class="link-box sm:hidden mx:flex">
          <svg-icon [iconName]="'cart_head.svg'" style="font-size: 24px;" class="mr6"></svg-icon>
          <span class="font16-w500" *ngIf="productList?.length > 0">{{ productList?.length }}</span>
        </span>
      </div>
      <!-- language setting -->
      <!-- <span class="header-content-right-lang" (click)="changeLanguage()">{{ language == "en" ? "EN" : "ZH" }}</span> -->
      <span class="link-box sm:hidden mx:flex">
        <nz-select [ngModel]="language" [nzDropdownMatchSelectWidth]="false" nzSize="small" class="language-setting"
          [nzSuffixIcon]="nzSuffixIcon" (ngModelChange)="changeLanguage()">
          <ng-template #nzSuffixIcon>
            <svg-icon [iconName]="'arrow-down.svg'"></svg-icon>
          </ng-template>
          <nz-option nzValue="en" nzLabel="EN"></nz-option>
          <nz-option nzValue="zh" nzLabel="中文"></nz-option>
        </nz-select>
      </span>
      <!-- User / My Account -->



      <div class="app-header__menu-mobile sm:flex mx:hidden sm:px-0">
        <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu" class="menu-icon sm:px-3 sm:pt-[30px]" >
          <i nz-icon nzType="menu" nzTheme="outline"></i>
        </a>

        <!-- // to replace -->
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul class="app-header__menu-mobile-list" nz-menu>
            <li *ngIf="isLogin && userData?.queryUserPageInfoResDTO?.status==2">
              <div class="app-header__menu-mobile-item" *ngFor="let menu of menuItems" (click)="goPage(menu.url,true)">
                {{ menu.title }}
              </div>
            </li>
            <li *ngIf="!isLogin || userData?.queryUserPageInfoResDTO?.status!==2 || (!menuItems?.length)">
              <div class="app-header__menu-mobile-item"
                (click)="goPageWidthoutLogin('home/index',(isLogin &&userData?.queryUserPageInfoResDTO?.status==2 && menuItems.length==0) ? true : false)">
                {{"HOME_PAGE" | translate}}
              </div>
              <div class="app-header__menu-mobile-item"
                (click)="goPageWidthoutLogin('ecatalog',(isLogin &&userData?.queryUserPageInfoResDTO?.status==2 && menuItems.length==0) ? true : false)">
                {{"HOME_ECATALOG" | translate}}
              </div>
              <div class="app-header__menu-mobile-item"
              (click)="goPageWidthoutLogin('documents',(isLogin &&userData?.queryUserPageInfoResDTO?.status==2 && menuItems.length==0) ? true : false)">
              {{"DOWNLOAD_CENTER" | translate}}
            </div>
            </li>
            <li *ngIf="isLogin && userData?.queryUserPageInfoResDTO?.status==2" class="app-header__menu-mobile-item"
              (click)="showMessage()">
              {{"NOTIFICATION" | translate}}
            </li>
            <li class="app-header__menu-mobile-item" *ngIf="isLogin && userData?.queryUserPageInfoResDTO?.status==2">
              <div nz-popover [nzPopoverContent]="cartTemplate">
                {{"CART" | translate}}
              </div>
            </li>
            <!-- <li class="app-header__menu-mobile-item">
            <a href="https://stage.singlekey-id.com.cn/auth/connect/authorize?client_id=ciamids_003AF27B-4CDE-4F41-87F3-B1EC7C97D147&response_type=code&redirect_uri=https%3A%2F%2Fprm-ent.xiaoshouyi.com%2Fglobal%2Fsso%2Fcallback%2F00AP57FC2005FC72F151A3DA3021BCE7F40D.action&scope=openid%20phone&state=%2Fjson%2Fglobal_custom_menu%2Fsearch-custom-menu.action%3FmenuId%3D3380537547267057%2526frm%3D1"  target="_blank" rel="noopener noreferrer">{{ "REBATE_AND_MARKETING_FEE_INQUIRY" | translate }}</a>
          </li> -->
            <li class="app-header__menu-mobile-item">
              <span class="link-box">
                <nz-select [ngModel]="language" [nzDropdownMatchSelectWidth]="false" nzSize="small"
                  class="language-setting" [nzSuffixIcon]="nzSuffixIcon" (ngModelChange)="changeLanguage()">
                  <ng-template #nzSuffixIcon>
                    <svg-icon [iconName]="'arrow-down.svg'"></svg-icon>
                  </ng-template>
                  <nz-option nzValue="en" nzLabel="EN"></nz-option>
                  <nz-option nzValue="zh" nzLabel="中文"></nz-option>
                </nz-select>
              </span>
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </div>
  </div>
  <div class="app-header__company-name sm:block mx:hidden sm:pr-4">{{this.headerCompanyName | translate}}</div>
  <!-- Menu container -->
   <!-- // to replace -->
   <nav class="app-header__menu-container sm:hidden mx:flex" [nzWrapClassName]="'my-menu-wrapper'">
    <div class="menu-wrapper">
      <button nz-button nzType="default" class="arrow-button left" (click)="scrollLeft()" *ngIf="canScrollLeft">
        <i nz-icon nzType="left"></i>
      </button>
      <div class="menu-container" #scrollContainer>
        <ul nz-menu nzMode="horizontal">
          <ng-container *ngFor="let item of menuItemsToDisplay">
            <li *ngIf="item.type === 'item'" nz-menu-item [nzSelected]="item.selectedKey"
              (click)="goMenuPage(item.url, item.needCountry, item.pageKey, item.params)">
              {{item.title | translate}}
            </li>
            <li *ngIf="item.type === 'submenu'" nz-submenu nzTitle="{{item.title | translate}}"
              [ngClass]="{'highlighted': item.selectedKey}" (click)="goMenuPage(item.url, item.needCountry, item.pageKey)">
              <ul>
                <li *ngFor="let group of item.groups" nz-menu-group nzTitle="{{group.title}}">
                  <!-- <img [src]="group.icon" [alt]="group.title" style="width: 1.4rem;"> -->
                  <ul>
                    <ng-container *ngFor="let subItem of group.items">
                      <li nz-menu-item [nzSelected]="subItem.selectedKey"
                        (click)="openSubPage(subItem.pageKey, subItem.needCountry, subItem.url); $event.stopPropagation()">
                        {{subItem.title}}
                      </li>
                    </ng-container>
                  </ul>
                </li>
              </ul>
            </li>
          </ng-container>
        </ul>
      </div>
      <button nz-button nzType="default" class="arrow-button right" (click)="scrollRight()" *ngIf="canScrollRight">
        <i nz-icon nzType="right"></i>
      </button>
    </div>
    <div class="app-header__company-name">{{this.headerCompanyName | translate}}</div>
  </nav>


    <!-- <nav class="app-header__menu-container sm:hidden mx:flex" *ngIf="!isSalesPortal">
    <ul class="app-header__menu-list"
      *ngIf="!isLogin || userData?.queryUserPageInfoResDTO?.status!==2 || (!menuItems?.length)">
      <li class="app-header__menu-item"
        (click)="goPageWidthoutLogin('home/index',(isLogin &&userData?.queryUserPageInfoResDTO?.status==2 && menuItems.length==0) ? true : false)">
        {{"HOME_PAGE" | translate}}
      </li>
      <li class="app-header__menu-item"
        (click)="goPageWidthoutLogin('ecatalog',(isLogin &&userData?.queryUserPageInfoResDTO?.status==2 && menuItems.length==0) ? true : false)">
        {{"HOME_ECATALOG" | translate}}</li>
      <li *ngIf="showDocuments"
        class="app-header__menu-item"
        (click)="goPageWidthoutLogin('documents',(isLogin &&userData?.queryUserPageInfoResDTO?.status==2 && menuItems.length==0) ? true : false)">
        {{"HOME_DOCUMENTS" | translate}}</li>
    </ul>
    <ul class="app-header__menu-list" *ngIf="isLogin && userData?.queryUserPageInfoResDTO?.status==2">
      <li class="app-header__menu-item" *ngFor="let menu of menuItems" (click)="goPage(menu.url,true)">{{ menu.title }}
      </li>
    </ul>

    <div class="app-header__company-name">{{this.headerCompanyName | translate}}</div>
  </nav> -->

  <div *ngIf="showAnnouncement" class="announcement-bar">
    <img src="assets/new/notification3.png" class = "announcement-icon">
    <span class="announcement-text">
      {{noticeDto.content}}
    </span>
    <button class="close-btn" (click)="closeAnnouncement()">×</button>
  </div>

  <!-- ---- Mobile Menu List  ----- -->
  <!-- Breadcrumb navigation -->

  <ng-template #cartTemplate>
    <div class="cart-content">
      <div class="flex-between">
        <span class="font18-w700">{{"CART" | translate}}({{ productList.length }})</span>
        <div class="flex-v-center cursor-pointer" (click)="deleteAll()">
          <svg-icon [iconName]="'delete.svg'" class="mr6 color-grey" [size]="20"></svg-icon>{{"CART_DEL_ALL" |
          translate}}
        </div>
      </div>
      <ul class="product-list mb20">
        <li clss="product mt20" *ngFor="let data of productList">
          <div class="flex-between">
            <span class="color-grey font16-w700">{{
              data.inputMaterialNumber || "--"
              }}</span><span class="color-disabled font14-w500">QTY: {{ data.quantity | number : "1.0-0" }}</span>
          </div>
          <div class="font14-w500 color-grey">
            {{ data.materialNumber || "--" }}
          </div>
        </li>
        <li *ngIf="productList.length == 0" class="no-data">
          {{ "CART_HEAD_EMPTY" | translate }}
        </li>
      </ul>
      <div class="primary-mid-btn" (click)="goPage('cart',true)">
        <svg-icon [iconName]="'cart_head_white.svg'" class="mr6" [size]="20"></svg-icon>{{ "OPEN_CART" | translate }}
      </div>
    </div>
  </ng-template>

  <ng-template #userTemplate>
    <div class="user-popover__content mx:w-100 sm:w-80 max-h-[calc(100vh-100px)] h-[570px] overflow-y-scroll">
      <div class="user-popover__userinfo">
        <div class="user-popover__userinfo-avatar" *ngIf="userData?.queryUserPageInfoResDTO?.name">
          {{ userData?.queryUserPageInfoResDTO?.lastName?.substring(0, 1) || '-' }}{{
          userData?.queryUserPageInfoResDTO?.firstName?.substring(0, 1) || '-' }}
        </div>
        <div class="user-popover__userinfo-name">{{ userData?.queryUserPageInfoResDTO?.name ?? "--" }}</div>
        <div class="user-popover__userinfo-role">
          <span class="role-tag">{{ userData?.queryUserPageInfoResDTO?.category || '--' }}</span>
        </div>
        <div class="user-popover__userinfo-email">{{ userData?.queryUserPageInfoResDTO?.email ?? "--" }}</div>
      </div>
      <ul class="user-popover__soldTo" *ngIf="isDealerPortal">
        <li class="user-popover__soldTo-item">
          <span class="label">{{ "SOLD_TO" | translate }}</span>
          <span class="value">{{ soldToData?.customerName }}</span>
        </li>
        <li class="user-popover__soldTo-item">
          <span class="label">{{ "SOLD_TO_NO" | translate }}</span>
          <span class="value">{{ soldToData?.customerCode }}</span>
        </li>
        <li class="user-popover__soldTo-item">
          <span class="label">{{ "SALES_AREA" | translate }}</span>
          <span
            class="value">{{soldToData.salesOrganization}}_{{soldToData.distributionChannel}}_{{soldToData.division}}
          </span>
        </li>
        <li class="user-popover__soldTo-item">
          <span class="label">{{ "CH3" | translate }}</span>
          <span class="value">{{ soldToData?.ch3Name }}</span>
        </li>
        <li class="user-popover__soldTo-item">
          <span class="label">{{ "CH3_CODE" | translate }}</span>
          <span class="value">{{ soldToData?.ch3 }}</span>
        </li>

      </ul>
      <ul class="user-popover__menu">
        <li class="user-popover__menu-item" (click)="goPage('user/my-account',true)">
          <svg-icon [iconName]="'new/globe.svg'" class="mr-2" [size]="20"></svg-icon>
          <span> {{ "MY_ACCOUNT" | translate }}</span>
        </li>
        <li class="user-popover__menu-item" (click)="goPage('user/data-privacy',true)">
          <svg-icon [iconName]="'new/globe.svg'" class="mr-2" [size]="20"></svg-icon>
          <span>{{ "DATA_PRIVACY" | translate }}</span>
        </li>
      </ul>
      <div class="user-popover__button" (click)="logOut()">
        <svg-icon [iconName]="'new/logout.svg'" class="mr-2" [size]="20"></svg-icon>{{ "LOG_OUT" | translate }}
      </div>
    </div>
  </ng-template>
  <!-- <div *ngIf="isLogin && isShow" class="fixed-text">
    <div class="chatbot flex-center flex-col">
      <p>
        {{ "CHAT" | translate}}
      </p>
      <p>
        {{ "BOT" | translate}}
      </p>
    </div>
  </div>
  <div *ngIf="isLogin" class="fixed-expand cursor-pointer">
    <div  *ngIf="!isShow" (click)="showOrHide($event)">
      {{ "SHOW" | translate}}
    </div>
    <div *ngIf="isShow" (click)="showOrHide($event)">
      {{ "HIDDEN" | translate}}
    </div>
  </div>
  <a *ngIf="isLogin && isShow" class="fixed-icon" (click)="goChatbot()">
    <img 
    src="assets/images/robot.gif" 
    alt="robot"
    width="80px"
    height="80px"
    />
  </a> -->
 
</div>

<!--Notification usage -->
<nz-modal [(nzVisible)]="isNotificationVisible" [nzTitle]="notificationTitle" [nzWidth]="convertPxToRem(1130)"
  nzCentered [nzClosable]="false" [nzFooter]="null" (nzOnCancel)="isNotificationVisible = false">
  <ng-template #notificationTitle>
    <div class="flex-between">
      <span class="modal-title">{{ "NOTIFICATION" | translate }}</span>
      <svg-icon (click)="isNotificationVisible = false" [iconName]="'close.svg'" [size]="20"
        class="close-svg cursor-pointer"></svg-icon>
    </div>
  </ng-template>
  <div *nzModalContent>
    <notification (handleCloseNotification)="handleClose($event)"></notification>
  </div>
</nz-modal>

<!--quick add -->
<nz-modal [(nzVisible)]="isVisible" [nzTitle]="modalTitleContent" [nzWidth]="'auto'" [nzContent]="modalContent"
  [nzFooter]="null" nzCentered [nzClosable]="false" [nzClassName]="'myModal'">
  <ng-template #modalTitleContent>
    <div class="flex-between modal-title">
      <span>{{"HOME_QUICK_ADD"|translate}}</span>
      <svg-icon [iconName]="'new/close.svg'" class="mr-3 cursor-pointer fr" (click)="isVisible = false"></svg-icon>
    </div>
  </ng-template>

  <ng-template #modalContent>
    <app-quick-add [isModal]="true" (closeModal)="isVisible = false"></app-quick-add>
  </ng-template>
</nz-modal>

<!-- User Info -->
<nz-modal [(nzVisible)]="userInfoVisible" [nzTitle]="userInfoTitle" [nzWidth]="convertPxToRem(742)" nzCentered
  (nzOnCancel)="userInfoVisible = false" [nzClosable]="false" [nzFooter]="null">
  <ng-template #userInfoTitle>
    <div class="flex-between">
      <span class="modal-title"></span>
      <svg-icon (click)="userInfoVisible = false" [iconName]="'close.svg'" [size]="20" class="close-svg cursor-pointer">
      </svg-icon>
    </div>
  </ng-template>